// Tokens for the public member-review page.
// sessionStorage (not Vuex): the Vuex store is persisted to localStorage.
//  - link token (X-Review-Token): from the emailed URL, says which policy.
//  - access token (X-Review-Access): returned by OTP verify, proves the code was
//    entered for that policy. Expires after ~30 min (backend then answers 401 otp_required).
const KEY = 'member_review_session';
const ACCESS_KEY = 'member_review_access';

function read(key) {
    try {
        return window.sessionStorage.getItem(key) || '';
    } catch (e) {
        return '';
    }
}

function write(key, value) {
    try {
        window.sessionStorage.setItem(key, value);
        return window.sessionStorage.getItem(key) === value;
    } catch (e) {
        return false;
    }
}

function remove(key) {
    try {
        window.sessionStorage.removeItem(key);
    } catch (e) {
        // storage unavailable: nothing to clear
    }
}

export default {
    get() {
        return read(KEY);
    },
    set(token) {
        return write(KEY, token);
    },
    getAccess() {
        return read(ACCESS_KEY);
    },
    setAccess(token) {
        return write(ACCESS_KEY, token);
    },
    clearAccess() {
        remove(ACCESS_KEY);
    },
    clear() {
        remove(KEY);
        remove(ACCESS_KEY);
    },
};
